/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { default as screensReducer } from "./screensSlice";
export {
  setActiveScreen,
  setLocationUrl,
  syncScreenFromUrl,
  pushNavigation,
  replaceNavigation,
  popNavigation,
  resetNavigationStack,
  selectActiveScreen,
  selectCurrentUrl,
  selectPreviousUrl,
  selectScreenController,
  selectNavigationStack,
  selectPreviousNavUrl,
  selectNavigationStackDepth,
  selectCanGoBack
} from "./screensSlice";
export type { ScreensState } from "./screens.types";
